"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataFromBase64 = void 0;
const js_base64_1 = require("js-base64");
const token_parse_error_1 = require("../../errors/token-parse-error");
function dataFromBase64(data) {
    try {
        return JSON.parse((0, js_base64_1.decode)(data));
    }
    catch (error) {
        throw new token_parse_error_1.TokenParseError(data);
    }
}
exports.dataFromBase64 = dataFromBase64;
//# sourceMappingURL=data-from-base64.js.map